<template>
    <svg aria-hidden="true" focusable="false" width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6.84946 3.19355L1 1V15.8065L6.84946 18L13.3387 15.8065L19.0968 18V3.19355L13.3387 1L6.84946 3.19355Z" stroke="#9D9FA2" stroke-linejoin="round" />
        <line x1="6.90912" y1="3.19354" x2="6.90912" y2="18" stroke="#9D9FA2" />
        <line x1="13.2454" y1="1" x2="13.2454" y2="15.8065" stroke="#9D9FA2" />
    </svg>
</template>
